import focus from './focus';

export default Vue => {
  Vue.directive('focus', focus);
};
